export default __webpack_public_path__ + "static/media/martin_botika.1cac812b.png";